<template>
    <div>
        <div class="banner-tramites-externos p-5">
            <img src="@/assets/imagenes/hacienda_chiapas.png" alt="LogoHaciendaChiapas">
        </div>
        <section class="buscador-cards container mb-5 mt-1">
            <div>
                <div class="mt-1 mb-4">
                    <div id="menu">
                        <ul class="nav nav-tabs d-flex justify-content-center" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a @click="busqueda(1), obtenerListado()" class="nav-link active" id="buscador-tab" data-toggle="tab" href="#buscador" role="tab" aria-controls="buscador" aria-selected="true">Buscador</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a @click="busqueda(2), textInput=''" class="nav-link" id="organos-tab" data-toggle="tab" href="#organos" role="tab" aria-controls="organos" aria-selected="false">Buscar por Órganos Administrativos </a>
                            </li>
                        </ul>
                    </div>
                    <!-- <boton-atras :nombre_ruta="'modulo-planeacion'"></boton-atras> -->
                    <div v-if="tabBuscador">
                        <h2 class="mt-3 text-vino-strong text-center">BUSCADOR DE FORMATOS</h2>
                        <div class="d-flex justify-content-center">
                            <div class="input-group input-group-lg tab-buscador">
                                <div class="input-group-prepend">
                                    <span class="input-group-text bg-white pr-1" style="border-right:none; color: #a3a3a3;" id="inputGroup-sizing-lg"><i class="fas fa-search"></i></span>
                                </div>
                                <input type="text" v-model.trim="textInput" style="border-left:none;"  class="form-control" placeholder="Buscar..." aria-label="Sizing example input" aria-describedby="inputGroup-sizing-lg">
                            </div>
                            <!-- <div class="input-group input-group-width">
                                <input v-model.trim="textInput" type="text" class="form-control form-control-lg" placeholder="Ingrese una palabra...">
                            </div>  -->
                        </div>
                    </div>
                    <div v-else>
                        <h2 class="mt-3 text-vino-strong text-center" style="letter-spacing: 0; font-size: 1.5rem;">BUSCADOR POR ÓRGANOS ADMINISTRATIVOS</h2>
                        <div class="d-flex justify-content-center">
                            <div class="width__">
                                <select v-model="idSubsecretaria" class="custom-select custom-select-lg" id="subsecretaria">
                                    <option :value="null" disabled>Consultar órgano administrativo</option>
                                    <option v-for="(n,index) in subsecretarias" :key="index" :value="n.id">{{n.descripcion}}</option>
                                </select>
                            </div>
                            <div class="width__">
                                <select v-model="idDireccion" class="custom-select custom-select-lg" id="direccion">
                                    <option :value="null" disabled>Consultar dirección</option>
                                    <option v-for="(n,index) in direcciones" :key="index" :value="n.id">{{n.descripcion}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cards-result">
                    <!-- SPINER SHOW -->
                    <div v-show="load" class="text-center pt-5">
                        <spiner></spiner>
                        <p class="mt-0">Buscando formatos...</p>
                    </div>
                    <!-- VALIDACION SI NO TRAE RESULTADOS DE DIRECCION LA SUBSECRETARIA ESCOGIDA -->
                    <div v-if="ErrorRespuesta==1" class="w-100 text-center py-5">
                        <p class="sinResult text-muted mb-0">El órgano escogido no tiene direcciones asociadas</p>
                    </div>
                    <!-- VALIDACION SI NO TRAE RESULTADOS BUSQUEDA DE SUBSECRETARIA Y DIRECCION -->
                    <div v-if="ErrorRespuesta==2" class="w-100 text-center py-5">
                        <p class="sinResult text-muted mb-0">Sin resultados</p>
                        <i class="far fa-frown fa-2x" style="color:#bebebe;"></i>
                    </div>

                    <!-- BUSCADOR NO ENCONTRO RESULTADOS -->
                    <div v-if="textInput !== '' && resultadoBusqueda.length==0" class="container">
                        <div class="no-result text-center mb-3" style="color: #bfbfbf">
                            <p class="sinResult text-muted mt-5 mb-0">Sin resultados</p>
                            <i class="far fa-frown fa-2x"></i>
                        </div>
                    </div>

                    <!-- SI EL INPUT DE BUSQUEDA ESTA VACIO, COLOCA TODAS LAS CARDS -->
                    <div v-if="textInput == '' && resultadoBusqueda.length==0" class="py-4">
                        <div class="container-tarjetas">
                            <stack
                                :column-min-width="300"
                                :gutter-width="15"
                                :gutter-height="15"
                                monitor-images-loaded>
                                <stack-item
                                v-for="(tramite, indice) in listadoTramites" :key="indice"
                                style="transition: transform 300ms"
                                >
                                <div class="tarjeta-tramite">
                                    <div class="contenedor-nombre_telUrl row  p-0 d-flex justify-content-between">
                                        <div class="col-9 px-3 pt-3">
                                            <h6 style="font-size: 1.1rem;" id="nombreTramite">{{tramite.nombre}}</h6>
                                        </div>
                                        <div class=" col-3 px-0 text-right d-flex justify-content-end align-items-center" style="">
                                            <small class="card-categoria px-2 py-1" style="margin-right: -3px;">
                                                {{tramite.categoria}}
                                            </small>
                                        </div>
                                    </div>
                                        <hr class="my-0">
                                    <div class="container-img mt-0">
                                        <p class="m-0 p-0 text-gris-light" style="font-size: .8rem;" id="modalidadServicio">{{tramite.codigoFormato}} | Revisión y fecha: {{tramite.revision}} {{tramite.fechaVigor}} </p>
                                        <p class="text-gris-strong mb-0">{{tramite.descripcion}}</p>
                                        <p class="mt-0 mb-4 p-0 text-muted"># {{tramite.palabrasClave}}</p>


                                        <div class="icono_modalidad mt-5">
                                            <div class="w-100">
                                                <ul class="d-flex justify-content-between">
                                                    <li><a :href="tramite.urlServicioTramite? tramite.urlServicioTramite : '#'" :target="tramite.urlServicioTramite? '_blank' : ''"> Trámite </a></li>
                                                    <li><a :href="tramite.urlFormato? tramite.urlManual : '#'" :target="tramite.urlFormato? '_blank' : ''"> Instructivo </a></li>
                                                    <li><a :href="tramite.urlManual? tramite.urlFormato : '#'" :target="tramite.urlManual? '_blank' : ''"> Formato </a></li>
                                                    <li><a :href="tramite.urlAvisoPrivacidad? tramite.urlAvisoPrivacidad : '#'" :target="tramite.urlAvisoPrivacidad? '_blank' : ''"> Aviso de Privacidad </a></li>
                                                </ul>
                                            </div>
                                            <img  src="" alt="" style="width:38px; position:absolute;">
                                        </div>
                                    </div>
                                </div>
                                </stack-item>
                            </stack>
                        </div>
                    </div>
                    <!-- SI HAY UNA BUSQUEDA, HACE EL FILTRADO Y MUESTRA LAS CARDS PRODUCTO DE ELLO -->
                    <div v-else class="py-4">
                        <div class="container-tarjetas">
                            <stack
                                :column-min-width="300"
                                :gutter-width="15"
                                :gutter-height="15"
                                monitor-images-loaded>
                                <stack-item
                                v-for="(tramite, indice) in resultadoBusqueda" :key="indice"
                                style="transition: transform 300ms"
                                >
                                <div class="tarjeta-tramite">
                                    <div class="contenedor-nombre_telUrl row  p-0 d-flex justify-content-between">
                                        <div class="col-9 px-3 pt-3">
                                            <h6 style="font-size: 1.1rem;" id="nombreTramite">{{tramite.nombre}}</h6>
                                        </div>
                                        <div class=" col-3 px-0 text-right d-flex justify-content-end align-items-center" style="">
                                            <small class="card-categoria px-2 py-1" style="margin-right: -3px;">
                                                {{tramite.categoria}}
                                            </small>
                                        </div>
                                    </div>
                                        <hr class="my-0">
                                    <div class="container-img mt-0">
                                        <div class="m-0 p-0 d-flex justify-content-between">
                                            <p class="m-0 p-0 text-gris-light" style="font-size: .8rem;" id="modalidadServicio">{{tramite.codigoFormato}} | Revisión y fecha: {{tramite.revision}} {{tramite.fechaVigor}}</p>
                                            <!-- <p class="m-0 p-0 text-gris-light" style="font-size: .8rem;">Tramite</p> -->
                                        </div>
                                        <p class="text-gris-strong">{{tramite.descripcion}}</p>
                                        <p class="mt-0 mb-4 p-0 text-muted"># {{tramite.palabrasClave}}</p>

                                        <div class="icono_modalidad mt-5">
                                            <div class="w-100">
                                                <ul class="d-flex justify-content-between">
                                                    <li><a :href="tramite.urlServicioTramite? tramite.urlServicioTramite : '#'" :target="tramite.urlServicioTramite? '_blank' : ''"> Trámite </a></li>
                                                    <li><a :href="tramite.urlManual? tramite.urlManual : '#'" :target="tramite.urlManual? '_blank' : ''"> Instructivo </a></li>
                                                    <li><a :href="tramite.urlFormato? tramite.urlFormato : '#'" :target="tramite.urlFormato? '_blank' : ''"> Formato </a></li>
                                                    <li><a :href="tramite.urlAvisoPrivacidad? tramite.urlAvisoPrivacidad : '#'" :target="tramite.urlAvisoPrivacidad? '_blank' : ''"> Aviso de Privacidad </a></li>
                                                </ul>
                                            </div>
                                            <img  src="" alt="" style="width:38px; position:absolute;">
                                        </div>
                                    </div>
                                </div>
                                </stack-item>
                            </stack>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- esto es un padding q le pongo para que el footer no se eleve en pantallas grandes -->
        <div v-if="maxHeight && (listadoTramites.length<9 || resultadoBusqueda.length<9)" style="padding-bottom:30%;"></div>
    </div>
</template>

<script>

import ServicesTramiteshacienda from '../../../services/serviciosTramites';
const _serviciosHacienda = new ServicesTramiteshacienda();
import { Stack, StackItem } from "vue-stack-grid";
import spiner  from '../../../views/spiner.vue';
import botonAtras from '../../button-atras.vue'

export default({
    name: 'tramitesExternos',
    components:{
        spiner,
        Stack,
        StackItem,
        spiner,
        botonAtras
    },
    data: function() {
        return{
            listadoTramites: [],
            textInput: '',
            resultadoBusqueda: [],
            tabBuscador: true,
            load: false,
            subsecretarias: '',
            idSubsecretaria: null,
            direcciones: '',
            idDireccion: null,
            ErrorRespuesta: 0,
        }
    },
    computed:{
        maxHeight(){ return window.screen.height>800? true : false }
    },
    methods:{
        busqueda(n){
            this.ErrorRespuesta = 0;
            if(n == 1) this.tabBuscador = true;
            else {
                // this.listadoTramites = [];
                this.tabBuscador = false;
                this.idSubsecretaria = null;
                this.idDireccion = null
            }
        },
        obtenerListado: async function(){
            this.load = true;
            let resultado = await _serviciosHacienda.getTramitesExternos();
            this.load = false;
            // console.log(resultado);
            this.listadoTramites = resultado.data;
            // console.log(this.listadoTramites);
        },

        filtrado(){
            // obtengo texto del input, es necesario limpiar cada vez q filtre para q no dupliq resultados
            let texto = this.textInput.toLowerCase();
            this.resultadoBusqueda = [];

            // for(comparo el nombre del tramite con el texto del input)
            for(let tramite of this.listadoTramites){
                let nombre = tramite.nombre.toLowerCase();
                let descripcion = tramite.descripcion.toLowerCase();
                let palabrasClave = tramite.palabrasClave.toLowerCase();

                // si hay resultados, armo objeto y lo guardo en el array de resultados
                if(nombre.indexOf(texto) !== -1 || descripcion.indexOf(texto) !== -1 || palabrasClave.indexOf(texto) !== -1){

                    let obj = {
                        codigoFormato: tramite.codigoFormato,
                        nombre: tramite.nombre,
                        descripcion: tramite.descripcion,
                        categoria: tramite.categoria,
                        fechaVigor: tramite.fechaVigor,
                        urlAvisoPrivacidad: tramite.urlAvisoPrivacidad,
                        urlServicioTramite: tramite.urlServicioTramite,
                        revision: tramite.revision,
                        urlFormato: tramite.urlFormato,
                        urlManual: tramite.urlManual,
                        novedades: tramite.novedades,
                        palabrasClave: tramite.palabrasClave,
                        idSubsecretaria: tramite.idSubsecretaria,
                        subsecretaria: tramite.subsecretaria,
                        idDireccion: tramite.idDireccion,
                        direccion: tramite.direccion
                    };
                    this.resultadoBusqueda.push(obj);
                }
            }
            //  console.log(texto);
            //  console.log(this.resultadoBusqueda);
        },
        getSubsecretarias: async function(){
            let result;
            this.load = true;
            result = await _serviciosHacienda.Subsecretarias();
            this.load = false;
            this.subsecretarias = result.data;
            //console.log(this.subsecretarias);
        },
        getDirecciones: async function(idsubsecretaria){
            this.ErrorRespuesta = 0;
            let result = null;
            this.load = true;
            this.banderaSinResultados = false;
            result = await _serviciosHacienda.GetDirecciones(idsubsecretaria); //result = await _serviciosHacienda.GetDirecciones(this.token,idsubsecretaria);
            this.direcciones = result.data;
            this.load = false;

            // valida si la idsubsecretaria escogida tiene o no direcciones
            this.ErrorRespuesta = (this.direcciones.length>0)? 0 : 1;

            //console.log(this.direcciones);
        },
        formatos: async function(idFormatos){
            this.listadoTramites = [];
            let result = null;
            this.load = true;
            result = await _serviciosHacienda.filtroGenericoFormatos(this.idSubsecretaria, this.idDireccion, 1, '');
            this.listadoTramites = result.data;
            this.load = false;

             // valida si la busqueda escogida tiene o resultados
            this.ErrorRespuesta = (this.listadoTramites.length>0)? 0 : 2;

            // console.log('this.listadoTramites');
            // console.log(this.listadoTramites);
        },
    },
    created(){
        this.obtenerListado();
        this.getSubsecretarias();
    },
    watch:{
       textInput: function(){
           if(this.textInput == '') {
               this.resultadoBusqueda = [];
               this.obtenerListado(); // <-- si cuando busca no consigue, y borra todo. hacer peticion a servicio
            }
           else this.filtrado();
       },
        idSubsecretaria: function(){
            if(this.idSubsecretaria){
                this.getDirecciones(this.idSubsecretaria);
            }
        },
        idDireccion: function(){
            console.log('direccion: '+ this.idDireccion);
            if(this.idDireccion){
                this.formatos();
            }
        },
        ErrorRespuesta: function () { // si la subsec escogida no tiene direcciones, limpia para q no traiga cards
            if(this.ErrorRespuesta == 1) this.listadoTramites = [];
          }


    },
    mounted(){
        window.scrollTo(0, 0);
    },
})
</script>
<style scoped>
    /* #menu{ margin-bottom: 5rem;} */
    .width__{ width: 35%;}

    #subsecretaria.custom-select{
        border-radius: 0;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        font-size: 1rem;
    }
    #direccion.custom-select{
        border-radius: 0;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        font-size: 1rem;
    }

    .banner-tramites-externos img{
        width:15rem;
    }


    .buscador-cards div h2{
        font-weight: 500;
        letter-spacing: .19rem;
    }

    .input-group-width{ width: 80%;}
    .form-control:focus { box-shadow: none; }
    .btn.focus, .btn:focus { box-shadow: none; }

    .color-grey{ border: 1px solid #ced4da; }
    .color-grey i {color: grey; font-size: 1.2rem;}
    .color-grey:hover{ background: #ededed; }


    .container-tarjetas { margin: 0 auto; }
    .tarjeta-tramite{
        width: 100%;
        height: auto;
        border-radius: 8px;
        padding: 1rem 1rem .5rem 1rem;

        /* ===Opcion2: sin la imagen de fondo=== */
        background-color: #fff;
        border: 2px solid #fff;
        /* box-shadow: -3px 11px 31px 3px rgba(0,0,0,.13); */
        box-shadow: 1px 10px 20px -10px rgba(0,0,0,0.6);
    }



    /* --- estilis de cards --- */
    .card-categoria {
        border: 1px solid transparent;
        border-top-left-radius:10px;
        border-bottom-left-radius:10px;
        background: #ddc9a37a;
        color: #a38271;
        /* background: #b9ded069;
        color: #235c4f99; */
    }
    #nombreTramite{ color: #5f5f5f; }
    /* #modalidadServicio{ color: #98989a; } */

    ul { margin: 0; padding: 0; }
    ul li {  list-style:none; }
    ul li a {
        text-decoration: none;
        color: grey;
        font-size: .65rem;
        background: #edededa2 ;
        padding: .2rem .5rem;
        border-radius: 10px;

    }


    .form-control:focus {
    color: #495057;
    background-color: #fff;
    border-color: #ced4da;
    }

    .tab-buscador {
        width: 75%;
        display: flex;
        justify-content: center;
    }

/* navs tabs inicio */
.nav-tabs { border-bottom: none;}
#menu .nav-tabs a{
    font-size: 1rem;
    padding: .49rem .89rem;
}
#menu .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #621132;
    background-color: transparent;
    border-color: 0;
    border-radius: 0;
    padding-bottom: .2rem;
    /* font-weight: bold; */
    border-bottom: 3px solid;
}
#menu .nav-tabs .nav-link { border: none; }
#menu .nav-item { color: #2b2b2b; font-weight: 600;}
#menu ul li a{
    background: none;
    color:  /*#4e4a4a;*/ black;
}
/* navs tabs fin */

/* media query */
@media only screen and (max-device-width : 900px) {
    .buscador-cards h2{
        font-size: 1.4rem;
        letter-spacing: .10rem;
    }
    .tab-buscador { width: 95%; }

    /* apartado de tabs  */
    .width__{ width: 50% !important;}
    #menu{ margin-bottom: 3rem !important;}
    .buscador-cards div h2 { letter-spacing: 0.1rem !important; }
    #menu .nav-tabs a { font-size: .8rem !important; }

}

</style>
